export default __webpack_public_path__ + "static/home-izquierda-fb86b71a175bc56cafc386d7231b98d1.png";